<template>
  <AsidePanel
    ref="asidePanel"
    cancelText="close"
    :components="computeTabsArray"
    :initialTabIndex="tabIndex"
    :isExpanded="isExpanded"
    :itemType="itemType"
    :showSaveButton="false"
    :viewport="viewport"
  >
    <template v-slot:avatar>
      <AsideIcon
        icon="policies"
      />
    </template>
  </AsidePanel>
</template>
<script>
import { ItemTypeConsts, PolicyConsts } from 'client/util/Constants';
import AsideIcon from 'client/components/AsidePanel/AsideIcon.vue';
import AsidePanel from 'client/components/AsidePanel/AsidePanel.vue';
import AsidePanelPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelPropsMixin';
import PolicyTemplateItemTable from 'client/components/ItemTable/PolicyTemplateItemTable.vue';
import RecommendedPoliciesItemTable from 'client/components/ItemTable/RecommendedPoliciesItemTable.vue';

const { policyTemplateTypes } = PolicyConsts;
const {
  android,
  ios,
  linux,
  mac,
  windows,
} = policyTemplateTypes;

export default {
  name: 'PoliciesChooserAsidePanel',

  components: {
    AsidePanel,
    AsideIcon,
  },

  mixins: [
    AsidePanelPropsMixin,
  ],

  props: {
    itemType: {
      type: String,
      default: ItemTypeConsts.policies,
    },
    os: {
      type: String,
      default: windows,
    },
  },

  computed: {
    computeTabList() {
      const tabList = {
        [windows]: 0,
        [mac]: 1,
        [linux]: 2,
        [ios]: 3,
        [android]: 4,
        recommended: 5,
      };
      return tabList;
    },
    computeTabsArray() {
      const { itemType } = this;
      let tabsArray = [
        {
          label: 'Windows',
          vueComponent: PolicyTemplateItemTable,
          vueComponentProps: { gettingStartedItemType: itemType, os: windows },
        },
        {
          label: 'Mac',
          vueComponent: PolicyTemplateItemTable,
          vueComponentProps: { gettingStartedItemType: itemType, os: mac },
        },
        {
          label: 'Linux',
          vueComponent: PolicyTemplateItemTable,
          vueComponentProps: { gettingStartedItemType: itemType, os: linux },
        },
        {
          label: 'iOS',
          vueComponent: PolicyTemplateItemTable,
          vueComponentProps: { gettingStartedItemType: itemType, os: ios },
        },
      ];

      if (this.$hasFeatureFlag(this.$featureFlags.androidEmmMvp)) {
        tabsArray.push(
          {
            label: 'Android',
            vueComponent: PolicyTemplateItemTable,
            vueComponentProps: { gettingStartedItemType: itemType, os: android },
          },
        );
      }

      tabsArray.push(
        {
          label: 'Recommended',
          vueComponent: RecommendedPoliciesItemTable,
          vueComponentProps: { gettingStartedItemType: itemType },
        },
      );

      if (this.itemType === ItemTypeConsts.osPatchManagement) {
        tabsArray = tabsArray.filter(obj => obj.label === 'Windows' || obj.label === 'Mac');
      }

      return tabsArray;
    },
    tabIndex() {
      if (!this.os) return 0;
      const os = this.os.toLowerCase();
      return this.computeTabList[os] || 0;
    },
  },

  beforeRouteLeave(to, from, next) {
    this.handleBeforeRouteLeave(to, from, next);
  },

  methods: {
    // This guard is needed here because of a race condition when the 'configure' button is clicked.
    // When destroyed, this aside panel resets the item in ConfigurationModel but it happens after
    // the new <ConfigurationAsidePanel> sets it with the selected templateId, thus having no
    // templateId when fetchItem is called by the new <ConfigurationAsidePanel>, showing a blank
    // panel because no policy template was retrieved.
    handleBeforeRouteLeave(to, from, next) {
      this.$refs.asidePanel.$destroy();
      next();
    },
  },

};
</script>
<style module>
@value (greyDark1) from '~css/colors.css';

.avatar path {
  fill: greyDark1;
}
</style>
